import { render } from "./doctorsidebar.vue?vue&type=template&id=65ee3aaa"
import script from "./doctorsidebar.vue?vue&type=script&lang=js"
export * from "./doctorsidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__